import React, { Component } from "react";
import Hero from "./Hero";
import Intro from "./Intro";

class HomeContainer extends Component {
  render() {
    return (
      <div>
        <Hero />
        <Intro />
      </div>
    );
  }
}

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/components/HomeContainer/index.jsx